var exports = {
  "wx": "InboxMessageHeader.module__header___YlhWMH",
  "LD": "InboxMessageHeader.module__headerLeft___YlhWMH",
  "$s": "InboxMessageHeader.module__headerActions___YlhWMH",
  "FW": "InboxMessageHeader.module__headerIconButton___YlhWMH",
  "nr": "InboxMessageHeader.module__headerIcon___YlhWMH",
};

module.exports = exports;
